import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

const content = {
  de: {
    title: 'Impressum',
    back: 'Zurück',
    sections: [
      { heading: 'Angaben gemäß § 5 TMG', text: 'EnBet Consulting UG\nIm Tal 30\n34270 Schauenburg\nDeutschland' },
      { heading: 'Kontakt', text: 'Telefon: 0176 23943896\nE-Mail: Info@enbet-consulting.de' },
      { heading: 'Umsatzsteuer-ID', text: 'Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:\nDE346037206' },
      { heading: 'Vertreten durch', text: 'Sebastian Funke, Geschäftsführer' },
      { heading: 'Berufsbezeichnung', text: 'Unternehmensberater – AI Business Strategy\nEnBet Consulting UG' },
      { heading: 'Haftungsausschluss', text: 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.' },
      { heading: 'Urheberrecht', text: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.' },
    ],
  },
  en: {
    title: 'Imprint',
    back: 'Back',
    sections: [
      { heading: 'Information according to § 5 TMG', text: 'EnBet Consulting UG\nIm Tal 30\n34270 Schauenburg\nGermany' },
      { heading: 'Contact', text: 'Phone: +49 176 23943896\nEmail: Info@enbet-consulting.de' },
      { heading: 'VAT ID', text: 'VAT identification number according to § 27a UStG:\nDE346037206' },
      { heading: 'Represented by', text: 'Sebastian Funke, Managing Director' },
      { heading: 'Professional title', text: 'Business Consultant – AI Business Strategy\nEnBet Consulting UG' },
      { heading: 'Disclaimer', text: 'The contents of our pages have been created with the utmost care. However, we cannot guarantee the accuracy, completeness and timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws pursuant to § 7 (1) TMG.' },
      { heading: 'Copyright', text: 'The content and works created by the site operators on these pages are subject to German copyright law. Duplication, processing, distribution, or any form of commercialization of such material beyond the scope of copyright law requires the prior written consent of the respective author or creator.' },
    ],
  },
};

export default function ImpressumPage({ onClose }) {
  const { lang } = useLanguage();
  const c = content[lang];

  return (
    <motion.div
      data-testid="impressum-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] bg-white overflow-y-auto"
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <button
          data-testid="impressum-back-btn"
          onClick={onClose}
          className="inline-flex items-center gap-2 text-[#1f1f1f]/60 text-sm uppercase tracking-[0.15em] hover:text-[#1f1f1f] transition-colors mb-12"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          <ArrowLeft size={16} /> {c.back}
        </button>

        <h1
          className="text-[#1f1f1f] text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[1.3] mb-16"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          {c.title}
        </h1>

        <div className="space-y-10">
          {c.sections.map((s, i) => (
            <div key={i} className="border-t border-[#e5e5e5] pt-6">
              <h2
                className="text-[#1f1f1f] text-lg font-bold uppercase tracking-[0.05em] mb-3"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                {s.heading}
              </h2>
              <p
                className="text-[#1f1f1f]/70 text-base leading-relaxed whitespace-pre-line"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {s.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
